import { useEffect } from "react";

function App() {
  useEffect(() => {
    window.location.href = "/login-styled.html";
  }, []);

  return null;
}

export default App;
